import { render, staticRenderFns } from "./drugPriceAudit.vue?vue&type=template&id=1a8112ff&scoped=true&lang=pug&"
import script from "./drugPriceAudit.vue?vue&type=script&lang=ts&"
export * from "./drugPriceAudit.vue?vue&type=script&lang=ts&"
import style0 from "./drugPriceAudit.vue?vue&type=style&index=0&id=1a8112ff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8112ff",
  null
  
)

export default component.exports